import React, { Component } from 'react';

class AboutArtisto extends Component {
  render() {
    return (
      <section className={this.props.background} id="about">
        <div className="container mt-5 mb-5">
          <div className="row pt-2 pb-2">
            <span className="col-12 txt-bold-40px txt-white txt-uppercase">Restaurant Italien</span>
            <p className="col-12 txt-thin">
              Depuis 2013, L’artisto s’est très vite fait une place de choix dans le cœur des gourmets
              <br />
              et des amateurs de la cuisine italienne.
              <br />
              Rien ne vaut les valeurs italiennes dans nos assiettes : Savoureuses, authentiques et familiales.
              <br />
              La carte ne se lit pas mais s’écoute, déclamée par le chef, rythmée par sa voix, dressée avec sa passion.
              <br />
              L’artisto, c’est notre assortiment explosif d’autenticita italiana.
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutArtisto;



// WEBPACK FOOTER //
// ./src/components/artisto/AboutArtisto.js